module.exports = __webpack_public_path__ + "static/media/sk.44e957ad.svg";